import React, { useState, useEffect, useCallback, useRef } from 'react';

import { useHistory } from 'react-router-dom';
import { FaMoneyBill } from 'react-icons/fa';
import { MdSearch } from 'react-icons/md';
import { IPaginate } from 'shared/interfaces';
import { useToast } from 'contexts';
import { ModalHandles } from 'components/Modal';

import {
  getFormasPagamento,
  deleteFormaPagamento,
} from 'services/api/formaPagamento';

import * as C from 'components';
import * as S from './styles';

import { IFormaPagamento } from '../interfaces';

export const FormaPagamentoList: React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();
  const [formasPagamento, setFormasPagamento] =
    useState<IPaginate<IFormaPagamento>>();
  const [formaPagamentoAtual, setFormaPagamentoAtual] =
    useState<IFormaPagamento>();
  const [loading, setLoading] = useState(false);
  const [term, setTerm] = useState('');
  const modalRemoverRef = useRef<ModalHandles>(null);

  const handleSearch = useCallback(
    ({ page, per_page }) => {
      setLoading(true);

      const params = {
        page,
        per_page,
        term,
      };

      getFormasPagamento(params)
        .then((data) => {
          setFormasPagamento(data);

          setLoading(false);
        })
        .catch((e) => {
          addToast({
            type: 'error',
            title: 'Ops, Erro',
            description: e.response?.data?.message,
          });

          setLoading(false);
        });
    },
    [addToast, term],
  );

  useEffect(() => {
    const params = {
      page: 1,
      per_page: 20,
    };

    handleSearch(params);
  }, [handleSearch]);

  const handleRemove = async (): Promise<void> => {
    try {
      await deleteFormaPagamento(formaPagamentoAtual!.id);

      if (!formasPagamento) return;

      const newList = formasPagamento.data.filter(
        (item) => item.id !== formaPagamentoAtual?.id,
      );
      setFormasPagamento({ ...formasPagamento, data: newList });

      modalRemoverRef.current?.closeModal();

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Registro removido com sucesso',
      });
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ops, Erro',
        description: 'Ocorreu um erro ao remover o registro',
      });
    }
  };

  const handleOpenModalRemover = useCallback(
    (formaPagamentoSelected: IFormaPagamento): void => {
      setFormaPagamentoAtual(formaPagamentoSelected);
      modalRemoverRef.current?.openModal();
    },
    [],
  );

  return (
    <S.Container>
      <C.HeaderBackground>
        <C.HeaderPage>
          <C.HeaderInfo title="Formas de Pagamento" icon={FaMoneyBill} />

          <S.ContainerSearch>
            <C.InputSearch
              title="Digite aqui o que deseja pesquisar"
              icon={MdSearch}
              placeholder="Pesquisar"
              onChange={(e) => setTerm(e.target.value)}
              onKeyDown={(e) => {
                e.key === 'Enter'
                  ? handleSearch({
                      page: 1,
                      per_page: formasPagamento?.per_page,
                    })
                  : {};
              }}
            />
          </S.ContainerSearch>

          <div>
            <C.Can checkPermission="formas_pagamento_create">
              <C.ButtonLink
                title="Adicionar Forma Pagamento"
                to="/formas-pagamento/new"
              >
                Adicionar
              </C.ButtonLink>
            </C.Can>
          </div>
        </C.HeaderPage>
      </C.HeaderBackground>

      <S.Panel>
        {loading ? (
          <C.Loader loading={loading} align="center" message="Carregando..." />
        ) : (
          <>
            <div className="tbl-content">
              <C.Table>
                <thead>
                  <tr>
                    <th className="text-left">Descrição</th>
                    <th className="text-center">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {formasPagamento &&
                    formasPagamento.data.map((item: IFormaPagamento) => (
                      <tr key={item.id}>
                        <td>{item.nome}</td>
                        <td className="text-center">
                          <C.PopUpMenu>
                            <C.Can checkPermission="formas_pagamento_update">
                              <button
                                type="button"
                                onClick={() =>
                                  history.push(
                                    `/formas-pagamento/edit/${item.id}`,
                                  )
                                }
                              >
                                <S.IconEdit
                                  title="Editar"
                                  size={24}
                                  color="#707070"
                                />
                                Editar
                              </button>
                            </C.Can>

                            <C.Can checkPermission="formas_pagamento_delete">
                              <button
                                type="button"
                                onClick={() => handleOpenModalRemover(item)}
                              >
                                <S.IconDelete
                                  title="Remover"
                                  size={24}
                                  color="#707070"
                                />
                                Remover
                              </button>
                            </C.Can>
                          </C.PopUpMenu>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </C.Table>
            </div>
          </>
        )}
        <S.PaginationContainer>
          {formasPagamento && (
            <C.Pagination
              page={formasPagamento?.page}
              total={formasPagamento?.total}
              per_page={formasPagamento?.per_page}
              last_page={formasPagamento?.last_page}
              onSearch={handleSearch}
            />
          )}
        </S.PaginationContainer>
      </S.Panel>

      <C.Modal ref={modalRemoverRef} options={{ width: '400px' }}>
        <C.ModalHeader>
          <C.ModalTitle>Você Confirma a EXCLUSÃO?</C.ModalTitle>
        </C.ModalHeader>
        <C.ModalBody>
          <p>O registro será removido completamente!</p>
        </C.ModalBody>
        <C.ModalFooter>
          <C.Position align="right">
            <C.Button
              variant="outline-secondary"
              onClick={() => modalRemoverRef.current?.closeModal()}
            >
              Cancelar
            </C.Button>
            <C.Button
              variant="primary"
              onClick={() => handleRemove()}
              style={{ marginLeft: '16px' }}
            >
              SIM, confirmo a exclusão
            </C.Button>
          </C.Position>
        </C.ModalFooter>
      </C.Modal>
    </S.Container>
  );
};
